import React, { useEffect, useRef, useState } from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Typography, Box, useMediaQuery } from "@mui/material";

//components
import KnowMoreButton from "../Buttons/KnowMoreButton";

//img
import GreyArrow from "../../img/GreyArrow.png";

//json2mq
import json2mq from "json2mq";

const useStyles = (theme) => ({
  box: {
    display: "flex",
    mt: { xs: "40px", md: "none" },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: { xs: "center", md: "space-between" },
    alignItems: "center",
    height: { xs: "inherit", md: "100%" },
  },
  title: {
    fontFamily: theme.typography.montserrat.bold,
    maxWidth: { xs: "285px", md: "160px", lg: "280px" },
    color: theme.palette.blue.main,
    fontSize: { xs: "25px", md: "18px" },
    lineHeight: "35px",
    textAlign: "center",
    mt: { xs: "35px", md: "70px", lg: "100px" },
  },
  subtitle: {
    fontFamily: theme.typography.anaHeim.regular,
    color: theme.palette.blue.main,
    fontSize: { xs: "20px", md: "15px", lg: "18px" },
    mt: "20px",
    textAlign: "center",
    width: { xs: "255px", md: "190px", lg: "256px" },
  },
  arrow: {
    bgcolor: "blue",
    display: { xs: "none", md: "flex" },
    justifyContent: "center",
  },
});

const Steps = ({ title, subtitle, img, index, path, innerRef }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const xs = useMediaQuery(
    json2mq({
      maxWidth: 899,
    })
  );
  const md = useMediaQuery(
    json2mq({
      maxWidth: 1200,
      minWidth: 900,
    })
  );
  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1535,
      minWidth: 1201,
    })
  );
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1536,
    })
  );

  const [height, setHeight] = useState("");

  const ref = useRef();

  useEffect(() => {
    if (ref && ref.current && ref.current.height) setHeight(ref.current.height);
  }, []);

  const stylesHelper = () => {
    if (xs)
      return {
        img: { width: "240px", height: "240px" },
        arrow: { width: "40x", height: "40px", margin: "0 12px 0 12px" },
      };
    else if (md)
      return {
        img: { width: "180px", height: "180px" },
        arrow: { width: "25px", height: "25px", margin: "77.5px 12px 0 12px" },
      };
    else if (xl || lg) {
      return {
        img: { width: "240px", height: "240px" },
        arrow: { width: "40x", height: "40px", margin: "100px 12px 0 12px" },
      };
    }
  };

  return (
    <Box sx={classes.box}>
      <Box sx={classes.container}>
        <img
          style={stylesHelper() && stylesHelper().img}
          src={img}
          alt={`step${index + 1}`}
          ref={ref}
        />
        <Typography sx={classes.title}>{title}</Typography>

        <Typography sx={classes.subtitle}>{subtitle}</Typography>

        <KnowMoreButton innerRef={innerRef} path={path} />
      </Box>
      {index !== 3 && (
        <Box sx={{ ...classes.arrow, height }}>
          <img
            src={GreyArrow}
            alt="arrow"
            style={stylesHelper() && stylesHelper().arrow}
          />
        </Box>
      )}
    </Box>
  );
};

export default Steps;
